import StakeTable from "./StakeTable";

export default StakeTable;